<template>
<div class="container">
  <div class="back" @click="goback"></div>
  <div class="prev" @click="prevPage"></div>
  <div class="next" @click="nextPage"></div>
  <div class="home" v-for="(item,i) in totalPage" :key="i">
    <!-- <NewBox v-for="(item,i) in test" :key="i" :arr="item" :num="i"/> -->
    <FlexBox v-for="(item,i) in box.list" :key="i" :arr="item" :num="i" />
    <BlankBox v-for="(item,i) in blankNum" :key="i" :num="i" :total="blankNum"></BlankBox>
    <PageList :page="totalPage" @getPage="getPage" />
  </div>
  <div class="bottombox">
    <div class="goBtn" @click="openShadow">
      {{ btn }}
    </div>
  </div>
  <div class="shadow" v-show="showpanel">
    <div class="panel" v-if="isGo == true">
      <div class="title">
        <div class="center">
          <p class="cn">{{ panel.start.title }}</p>
          <p class="en">{{ panel.start.en }}</p>
        </div>
      </div>
      <div class="choose">
        <div class="btn" @click="cancle">取消</div>
        <div class="btn" @click="goStart">{{ panel.start.button }}</div>
      </div>
    </div>
    <div class="panel" v-else>
      <div class="title">
        <div class="center">
          <p class="cn">{{ panel.end.title }}</p>
          <p class="en">{{ panel.end.en }}</p>
        </div>
      </div>
      <div class="choose">
        <div class="btn" @click="cancle">取消</div>
        <div class="btn" @click="goEnd">{{ panel.end.button }}</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import FlexBox from '@/components/FlexBox.vue'
import BlankBox from '@/components/BlankBox.vue'
import NewBox from '@/components/NewBox.vue'
import MyButton from '@/components/MyButton.vue'
import PageList from '@/components/PageList.vue'
// eslint-disable-next-line
import axios from 'axios'
export default {
  name: 'HomeView',                    
  components: {
    // eslint-disable-next-line
    FlexBox,BlankBox,PageList,NewBox,MyButton
  },
  data() {
    return {
      start:'开始',
      end:'结束',
      btn:'GO',
      isGo:false,
      showpanel:false,
      panel:{
        start:{
          title:'是否开始训练',
          en:'Do you want to start training',
          button:'立即开始'
        },
        end:{
          title:'是否结束训练',
          en:'Do you want to end training',
          button:'立即结束'
        }
      },
      allList:null,
      box:{
        list: [
        ],
      },
      blankList:[
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {}
      ],
      flag:[],
      blankNum:9,
      timer:'',
      totalPage:1,//总共页数
      currentPage:1,//当前页数
      pageSize:9,//每页显示数量
      page:1,//页码
      perPage:9,//页数
      list:null,
      fwlist:null,
      currentData:[],
      fwtest:[],
      test:[
       {
        "id": 4602,
        "fd_id": 78,
        "tcp_id": 497, 
        "qualified": "过轻过慢",
        "millisecond": 1680525428068,
        "time": 2978,
        "depth": "6",
        "rate": "105",
        "device_id": 342,
        "total":17,
        "content": "0c33343120ab0ba2dc142e",
        "created_at": "2023-04-03 20:37:08",
        "value": 5.7
      },{
        "id": 4602,
        "fd_id": 78,
        "tcp_id": 497, 
        "qualified": "过轻过慢",
        "millisecond": 1680525428068,
        "time": 2978,
        "depth": "3",
        "rate": "105",
        "device_id": 345,
        "total":17,
        "content": "0c33343120ab0ba2dc142e",
        "created_at": "2023-04-03 20:37:08",
        "fw": true,
        "value": 3.5
      },{
        "id": 4602,
        "fd_id": 78,
        "tcp_id": 497, 
        "qualified": "过轻过慢",
        "millisecond": 1680525428068,
        "time": 2978,
        "depth": "3",
        "rate": "105",
        "device_id": 346,
        "total":17,
        "content": "0c33343120ab0ba2dc142e",
        "created_at": "2023-04-03 20:37:08",
        "value": 2.1
      }],
      ptest:[
        {
          tcpId: "90",
          device_id: 1178, //设备id
          total: 8, //总次数
          qualifiedNum: 8, //合格数
          totalTime: 360, //运行时间秒数
          pass_rate: "0.51" //合格率
        },
        {
          tcpId: "90",
          device_id: 1188, //设备id
          total: 8, //总次数
          qualifiedNum: 8, //合格数
          totalTime: 1073, //运行时间秒数
          pass_rate: "0.60" //合格率
        },
        {
          tcpId: "90",
          device_id: 1198, //设备id
          total: 8, //总次数
          qualifiedNum: 8, //合格数
          totalTime: 1073, //运行时间秒数
          pass_rate: "0.90" //合格率
        }
      ],
    }
  },
  methods: {
    goback(){
      this.$router.back()
    },
    // 打开窗口
    openShadow(){
      this.isGo = !this.isGo
      this.showpanel = true
      // console.log(this.isGo)
    },
    // 取消关闭窗口
    cancle(){
      this.showpanel = false
      this.isGo = !this.isGo
    },
    // 开始练习
    goStart(){
      this.getData()
      this.timer = setInterval(() => {
        this.getData()
      }, 200);
      this.showpanel = false
      this.btn = 'END'
      axios.get("https://admin.xinsuoyv.com/index/start")
    },
    // 结束练习
    goEnd(){
      clearInterval(this.timer)
      this.showpanel = false
      this.btn = 'GO'
      localStorage.removeItem('listData')
      axios.get("https://admin.xinsuoyv.com/index/end").then((res)=>{
        let mData = res.data.data
        let test = JSON.stringify(mData)
        localStorage.setItem('listData',test)
        this.$router.push({name:'page2'})
      })
    },
    // 上一页
    prevPage(){
      if(this.totalPage<=1){
        this.totalPage = 1
      }else{
        this.page--;
        this.box.list = this.blankList
      }
    },
    // 下一页
    nextPage(){
      if(this.totalPage<=1){
        this.totalPage = 1
      }else{
        this.page++;
        this.box.list = this.blankList
      }
    },
    // pagelist圆点按钮
    getPage(val){
      this.page = val;
      this.box.list = this.blankList
      this.getData()
    },
    // 获取按压数据
    getData(){
      var that = this
      var newrate = 0
      var data = {
        page:this.page,
        perPage:this.perPage
      }
      axios.get("https://admin.xinsuoyv.com/index/practiceBatch",{params:data}).then((res)=>{
        let mData = res.data.data
        that.totalPage = Math.ceil(Number(mData.total) / 9)
        let mfw = mData.fwList
        let mlist = mData.list
        if(mfw.length !== 0){
          for(let i in mlist){
            for(let j in mfw){
              let value = mfw[j].fw
              if(mfw[j].device_id == mlist[i].device_id){
                mlist[i].fw = value
              }
            }
          }
        }
        if(mlist.length!==0){
          that.get_NewData(mlist);
        }else if(mlist.length == 0){
          // that.box.list = that.blankList
          console.log('00000')
        }
        that.blankNum = 9 - mlist.length

        that.allList = mlist
        that.list = mlist
        that.fwlist = mfw

        // if(mlist.length !== 0){
        //   that.totalPage = Math.ceil(Number(mlist.length) / 9)
        //   that.totalPage = that.totalPage == 0 ? 1 : that.totalPage 
        //   that.getCurrentData()
        // }
      })  
    },
    // 获取按压数据（新）
    get_NewData(arr){
      var that = this;
      var data = {
        page:this.page,
        perPage:this.perPage
      }
      var list = arr
      axios.get("https://admin.xinsuoyv.com/index/practiceBatchList",{params:data}).then((res)=>{
        let mData = res.data.data
        let plist = mData.list
        // console.log('新列表',plist)
        if(plist.length !==0){
          for(let i in plist){
            let str = plist[i].value
            let deep = that.getDeep(str)
            console.log(deep==this.flag[i])
            if(deep !== this.flag[i] || this.flag[i] === ''){
              this.flag[i] = deep
              // console.log(this.flag)
              if(deep>0){
                list[i].value = deep
              }else{
                list[i].value = 0
              }
            }else if(deep == this.flag[i] && deep == 0){
              list[i].rate = 0
            }
            // if(deep == 0){
            //   list[i].rate = 0
            // }else if(deep>0){
            //   list[i].value = deep
            // }else{
            //   list[i].value = 0 
            // }
          }
          that.box.list = list
          console.log('box.list加数据',that.box.list)
        }
      })
    },
    // 数据分页
    getCurrentData(){
      let begin = (this.currentPage - 1) * this.pageSize;
      let end = this.currentPage * this.pageSize;
      this.currentData = this.list.slice(
        begin,
        end
      )
      for(let i in this.currentData){
        this.box.list[i] = this.currentData[i]
      }
    },
    // 处理深度数据
    getDeep(value){
      var that = this;
      var str_type = value.substring(0,2);
      var str_num = value.substring(2,4);
      var deep = 0
      if(str_type === 'aa' || str_type === 'AA'){
        var num = parseInt(str_num,16);
        deep = parseFloat(num)/10
        return deep;
      }else if(str_type === 'bb' || str_type ==='BB'){
        var num = parseInt(str_num,16);
        deep = parseFloat(num)/10;
        return deep;
      }else if(str_type === 'cc' || str_type ==='CC'){
        deep = 0;
        return deep;
      }else if(value === 'cccc' || value ==='CCCC'){
        deep = 0;
        return deep;
      }
    },
    // 测试数据
    mytest(){
      var mlist = [
        {value: 'aa00', device_id: 342, tcp_id: 248},
        {value: 'aa1E', device_id: 345, tcp_id: 248},
        {value: 'bb3C', device_id: 346, tcp_id: 248}
      ]
      var rlist = []
      if(mlist.length !==0){
        for(let i in mlist){
          let str = mlist[i].value
          let deep = this.getDeep(str)
          console.log('deep',deep)
          console.log('rlist',rlist[i])
          console.log(rlist[i] === '')
          if(deep !== rlist[i] || rlist[i] === ''){
            console.log(i,'rate不变')
            rlist[i] = deep
            console.log(rlist)
            if(deep>0){
              this.test[i].value = deep
            }else{
              this.test[i].value = 0
            }
          }else if(deep == rlist[i] && deep == 0){
            console.log(i,'rate归0')
            this.test[i].rate = 0
          }
        }
      }
      console.log('test',this.test)
    }
  },
  mounted() {
    // this.mytest()
  },
  beforeDestroy() {
    clearInterval(this.timer)
    // this.clearInterval(this.timer)
  },
}
</script>

<style lang="less">
.container{
  width: 100%;
  height: 100vh;
  background: linear-gradient(#b8f0fe,80%,#fff);
  overflow: hidden;
  .back{
    position: absolute;
    left: .5rem;
    line-height: .75rem;
    width: .75rem;
    height: .75rem;
    color: #000;
    cursor: pointer;
  }
  .back::after{
    content: '';
    position: absolute;
    width: .3rem;
    height: .3rem;
    border-top: 1px solid #000;
    border-left: 1px solid #000;
    left: 0;
    bottom: .2rem;
    transform: rotate(-45deg);
    // transform-origin: 0;
  }
  .prev{
    position: absolute;
    width: .8rem;
    height: .8rem;
    top: 50%;
    transform: translateY(-50%);
    left: .2rem;
  }
  .prev::after{
    position: absolute;
    content: '';
    width: .4rem;
    height: .4rem;
    left: .2rem;
    border-top: 1px solid #000;
    border-left: 1px solid #000;
    transform: rotate(-45deg);
    cursor: pointer;
  }
  .next{
    position: absolute;
    width: .8rem;
    height: .8rem;
    top: 50%;
    transform: translateY(-50%);
    right: .2rem;
  }
  .next::after{
    position: absolute;
    content: '';
    width: .4rem;
    height: .4rem;
    right: .2rem;
    border-top: 1px solid #000;
    border-right: 1px solid #000;
    transform: rotate(45deg);
    cursor: pointer;
  }
  .start_btn{
    position: absolute;
    left: 0;
    top: .5rem;
  }
  .home{
    width: 18.75rem;
    max-width: 1080px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateY(-50%) translateX(-50%);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .bottombox{
    width: 250px;
    height: 250px;
    position: absolute;
    bottom: 0;
    left: 0;
    overflow: hidden;
    .goBtn{
      width: 250px;
      height: 250px;
      border-radius: 300px;
      background: #7de5ff;
      position: absolute;
      bottom: -50px;
      left: -50px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 48px;
      font-weight: 600;
      cursor: pointer;
    }
  }
  .shadow{
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .4);
    display: flex;
    justify-content: center;
    align-items: center;
    .panel{
      width: 350px;
      height: 300px;
      background: #fff;
      .title{
        height: 80%;
        width: 100%;
        .center{
          padding: 25% 0;
          text-align: center;
          height: 30%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .cn{
            font-size: 36px;
          }
          .en{
            font-size: 18px;
          }
        }

      }
      .choose{
        height: 20%;
        width: 100%;
        display: flex;
        .btn{
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 18px;
          cursor: pointer;
        }
        .btn:nth-child(2){
          background: #7de5ff;
          color: #fff;
        }
      }
    }
  }
}

</style>
